// import {  Tooltip } from '@mui/material';
import React, { useRef } from 'react'
import ReactToPrint from 'react-to-print';
import { ComponentToPrint } from './Print';
import PrintIcon from '@mui/icons-material/Print';
import { IconButton } from '@mui/material';


export default function BotonImprimir({ cabecera, lista, tipo }) {
    const componentRef = useRef();
    console.log(cabecera);
    return (
        <>
            <ReactToPrint
                // onAfterPrint={() => resetCarrito()}
                trigger={() => (
                 
                     
                        
                            <IconButton
                                size="large"
                                color="secondary"
                                >
                                <PrintIcon fontSize="large" />
                            </IconButton>
                        
                  
                )}
                content={() => componentRef.current}
            />
            <div style={{ display: "none" }}>
                <ComponentToPrint
                    ref={componentRef}
                    cabecera={cabecera}
                    lista={lista}
                    tipo={tipo}
                />
            </div>
        </>
    )
}
